import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('update_backup_codes'),
    subtitle: defineMessage('backup_codes'),
    downloadButton: defineMessage('download_codes_txt_file'),
    checkboxText: defineMessage('yes_i_have_saved_the_backup_codes'),
    buttonDone: defineMessage('done'),
    buttonGenerate: defineMessage('generage_new_codes'),
    onSuccess: defineMessage('new_backup_codes_were_generated'),
};
